var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyManifestationReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.623 0H2.62694C1.96427 0 1.375 0.4875 1.375 1.14844V22.7516C1.375 23.4125 1.96291 24 2.62422 24H12.225C12.4459 24 12.625 23.8211 12.625 23.6C12.625 23.379 12.4458 23.2 12.225 23.2H2.62422C2.40409 23.2 2.17502 22.9711 2.17502 22.7516V1.14844C2.17502 0.928922 2.40527 0.800016 2.62698 0.800016H18.6231C18.841 0.800016 18.975 0.931641 18.975 1.14689V15.15C18.975 15.3711 19.1541 15.55 19.375 15.55C19.5959 15.55 19.775 15.3711 19.775 15.15V1.14689C19.775 0.487125 19.2857 0 18.623 0Z",
    fill: "#334155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3708 2H10.2542C10.1138 2 10 2.17892 10 2.39998C10 2.62109 10.1138 2.79997 10.2542 2.79997H17.3708C17.5112 2.79997 17.625 2.62105 17.625 2.39998C17.625 2.17887 17.5112 2 17.3708 2Z",
    fill: "#334155"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5042 8H14.1208C14.0541 8 14 8.17892 14 8.39998C14 8.62109 14.0541 8.79997 14.1208 8.79997H17.5041C17.5709 8.79997 17.625 8.62105 17.625 8.39998C17.625 8.17887 17.5709 8 17.5042 8Z",
    fill: "#334155"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4042 3.80078H11.2208C11.0989 3.80078 11 3.9797 11 4.20077C11 4.42188 11.0989 4.60075 11.2208 4.60075H17.4041C17.5261 4.60075 17.625 4.42183 17.625 4.20077C17.625 3.9797 17.5261 3.80078 17.4042 3.80078Z",
    fill: "#334155"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4042 9.80078H11.2208C11.0989 9.80078 11 9.9797 11 10.2008C11 10.4219 11.0989 10.6008 11.2208 10.6008H17.4041C17.5261 10.6008 17.625 10.4218 17.625 10.2008C17.625 9.9797 17.5261 9.80078 17.4042 9.80078Z",
    fill: "#334155"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4708 5.60156H13.1542C13.069 5.60156 13 5.78048 13 6.00155C13 6.22266 13.069 6.40153 13.1542 6.40153H17.4708C17.556 6.40153 17.625 6.22261 17.625 6.00155C17.625 5.78048 17.556 5.60156 17.4708 5.60156Z",
    fill: "#334155"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 11.6016H12.1875C12.0839 11.6016 12 11.7805 12 12.0015C12 12.2227 12.084 12.4015 12.1875 12.4015H17.4375C17.541 12.4015 17.625 12.2226 17.625 12.0015C17.625 11.7805 17.541 11.6016 17.4375 11.6016Z",
    fill: "#334155"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7319_74293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12516 2.625C7.24016 2.625 7.3335 2.71833 7.3335 2.83333V3.25H8.16683C8.28183 3.25 8.37516 3.34333 8.37516 3.45833V5.95833H8.79183V6.375H4.2085V5.95833H4.62516V3.45833C4.62516 3.34333 4.7185 3.25 4.8335 3.25H5.66683V2.83333C5.66683 2.71833 5.76016 2.625 5.87516 2.625H7.12516ZM5.66683 3.66667H5.04183V5.95833H5.66683V3.66667ZM6.91683 3.66667H6.0835V5.95833H6.91683V3.66667ZM7.9585 3.66667H7.3335V5.95833H7.9585V3.66667ZM6.91683 3.04167H6.0835V3.25H6.91683V3.04167Z",
    fill: "#334155"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7319_74293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12516 8.625C7.24016 8.625 7.3335 8.71833 7.3335 8.83333V9.25H8.16683C8.28183 9.25 8.37516 9.34333 8.37516 9.45833V11.9583H8.79183V12.375H4.2085V11.9583H4.62516V9.45833C4.62516 9.34333 4.7185 9.25 4.8335 9.25H5.66683V8.83333C5.66683 8.71833 5.76016 8.625 5.87516 8.625H7.12516ZM5.66683 9.66667H5.04183V11.9583H5.66683V9.66667ZM6.91683 9.66667H6.0835V11.9583H6.91683V9.66667ZM7.9585 9.66667H7.3335V11.9583H7.9585V9.66667ZM6.91683 9.04167H6.0835V9.25H6.91683V9.04167Z",
    fill: "#334155"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7319_74293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7915 14.3752H17.6248C17.7464 14.3752 17.863 14.4235 17.9489 14.5094C18.0349 14.5954 18.0832 14.7119 18.0832 14.8335V22.1668C18.0832 22.2884 18.0349 22.405 17.9489 22.4909C17.863 22.5769 17.7464 22.6252 17.6248 22.6252H9.37484C9.25328 22.6252 9.1367 22.5769 9.05075 22.4909C8.96479 22.405 8.9165 22.2884 8.9165 22.1668V14.8335C8.9165 14.7119 8.96479 14.5954 9.05075 14.5094C9.1367 14.4235 9.25328 14.3752 9.37484 14.3752H11.2082V13.4585H12.1248V14.3752H14.8748V13.4585H15.7915V14.3752ZM14.8748 15.2918H12.1248V16.2085H11.2082V15.2918H9.83317V17.1252H17.1665V15.2918H15.7915V16.2085H14.8748V15.2918ZM17.1665 18.0418H9.83317V21.7085H17.1665V18.0418ZM10.7498 19.4168H11.6665V20.3335H10.7498V19.4168ZM12.5832 19.4168H16.2498V20.3335H12.5832V19.4168Z",
    fill: "#334155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7319_74293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    fill: "white",
    transform: "translate(4 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7319_74293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    fill: "white",
    transform: "translate(4 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7319_74293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(8 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyManifestationReport);
export default __webpack_public_path__ + "static/media/dailyManifestationReport.b15ee84f5dfe4cdfede1078b4c2f2a36.svg";
export { ForwardRef as ReactComponent };